import { Box, Tooltip, Typography } from '@mui/material';
import { LogoutOutlined } from '@ant-design/icons';

import { IconButton } from '~/components/IconButton';
import { useAppDispatch, useAppSelector } from '~/application/hooks';
import { selectUser, setAuthToken } from '~/application/store/auth';

export const UserLogout = () => {
    const user = useAppSelector(selectUser);
    const dispatch = useAppDispatch();

    return user && (
        <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1, flexShrink: 0, ml: 0.75 }}>
            <Typography variant="subtitle1">{user?.name}</Typography>
            <Tooltip title="Odjava">
                <IconButton onClick={() => dispatch(setAuthToken(null))}>
                    <LogoutOutlined />
                </IconButton>
            </Tooltip>
        </Box>
    );
};
